import { render, staticRenderFns } from "./informeLeechero.vue?vue&type=template&id=28f68980&scoped=true&"
import script from "./informeLeechero.vue?vue&type=script&lang=js&"
export * from "./informeLeechero.vue?vue&type=script&lang=js&"
import style0 from "./informeLeechero.vue?vue&type=style&index=0&id=28f68980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f68980",
  null
  
)

export default component.exports